import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { DownloadFilesService } from 'src/app/services/download-files.service';
import { environment } from 'src/environments/environment';
import { Account } from './models/account';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {
  activeProfileName: string;
  activeProfileRoles: string[];
  administratorAccess = false;

  constructor(private downloadFilesService: DownloadFilesService, private authService: MsalService) { }

  ngOnInit() {
    this.administratorAccess = (this.authService.instance.getAllAccounts()[0]).idTokenClaims['roles'].includes(environment.roleAdministrator);

    let account: Account = this.authService.instance.getAllAccounts()[0];

    if (account) {
      this.activeProfileName = account.name;

      if (account.idTokenClaims?.roles) {

        this.activeProfileRoles = account.idTokenClaims.roles;
      }
    }
  }

  logout() {
    this.authService.logoutRedirect();
  }

  exportFieldsClassificationXlsx() {
    this.downloadFilesService.downloadFieldsClassificationXlsx();
  }

  exportSalesDTAXlsx() {
    this.downloadFilesService.downloadSalesDTAXlsx();
  }

  downloadAllPolygonsKMZ() {
    this.downloadFilesService.downloadAllPolygonsKMZ();
  }
}
